import { render, staticRenderFns } from "./EventDetailsTimeStep.vue?vue&type=template&id=131b6bf3"
import script from "./EventDetailsTimeStep.vue?vue&type=script&lang=js"
export * from "./EventDetailsTimeStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports